import { render } from "./RefreshConfig.vue?vue&type=template&id=3ebdfef8&scoped=true"
import script from "./RefreshConfig.vue?vue&type=script&lang=js"
export * from "./RefreshConfig.vue?vue&type=script&lang=js"

import "./RefreshConfig.vue?vue&type=style&index=0&id=3ebdfef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebdfef8"]])

export default __exports__